import { AD_UNIT_IDS } from '@/constants/ad';
import type { AdSlotPositionRule } from '@/utils/adSlotPosition';

import type { NativeAdSlotConfig } from './NativeAdSlot';

interface SearchAdPlacementConfig {
  positionRule: AdSlotPositionRule;
  nativeSlot: NativeAdSlotConfig;
}

const ROW_RESULT_RULE = {
  firstPosition: 3,
  hideWhenListLengthAtMost: 2,
} as const satisfies AdSlotPositionRule;

const GRID_RESULT_RULE = {
  firstPosition: 4,
  hideWhenListLengthAtMost: 3,
} as const satisfies AdSlotPositionRule;

export const SEARCH_AD_PLACEMENTS = {
  'search-all-policy': {
    positionRule: ROW_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_ALL_POLICY_M,
      unitIdP: AD_UNIT_IDS.SEARCH_ALL_POLICY_P,
      mWidth: 375,
      mHeight: 163,
      pWidth: 600,
      pHeight: 189,
      rounded: 'medium',
    },
  },
  'search-all-hometowns': {
    positionRule: ROW_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_ALL_HOMETOWNS_M,
      unitIdP: AD_UNIT_IDS.SEARCH_ALL_HOMETOWNS_P,
      mWidth: 375,
      mHeight: 163,
      pWidth: 600,
      pHeight: 143,
      rounded: 'medium',
    },
  },
  'search-all-policy-guide': {
    positionRule: ROW_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_ALL_POLICY_GUIDE_M,
      unitIdP: AD_UNIT_IDS.SEARCH_ALL_POLICY_GUIDE_P,
      mWidth: 375,
      mHeight: 163,
      pWidth: 600,
      pHeight: 143,
      rounded: 'medium',
    },
  },
  'search-all-gift': {
    positionRule: GRID_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_ALL_GIFT_M,
      unitIdP: AD_UNIT_IDS.SEARCH_ALL_GIFT_P,
      mWidth: 161,
      mHeight: 303,
      pWidth: 189,
      pHeight: 307,
      rounded: 'medium',
    },
  },
  'search-all-donation-business': {
    positionRule: GRID_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_ALL_DONATION_BUSINESS_M,
      unitIdP: AD_UNIT_IDS.SEARCH_ALL_DONATION_BUSINESS_P,
      mWidth: 335,
      mHeight: 90,
      pWidth: 600,
      pHeight: 120,
      rounded: 'medium',
    },
  },
  'search-all-local-market': {
    positionRule: GRID_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_ALL_LOCAL_MARKET_M,
      unitIdP: AD_UNIT_IDS.SEARCH_ALL_LOCAL_MARKET_P,
      mWidth: 161,
      mHeight: 330,
      pWidth: 189,
      pHeight: 364,
      rounded: 'medium',
    },
  },
  'search-policy': {
    positionRule: ROW_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_POLICY_M,
      unitIdP: AD_UNIT_IDS.SEARCH_POLICY_P,
      mWidth: 375,
      mHeight: 163,
      pWidth: 600,
      pHeight: 189,
      rounded: 'medium',
    },
  },
  'search-hometowns': {
    positionRule: ROW_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_HOMETOWNS_M,
      unitIdP: AD_UNIT_IDS.SEARCH_HOMETOWNS_P,
      mWidth: 375,
      mHeight: 163,
      pWidth: 600,
      pHeight: 143,
      rounded: 'medium',
    },
  },
  'search-policy-guide': {
    positionRule: ROW_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_POLICY_GUIDE_M,
      unitIdP: AD_UNIT_IDS.SEARCH_POLICY_GUIDE_P,
      mWidth: 375,
      mHeight: 163,
      pWidth: 600,
      pHeight: 143,
      rounded: 'medium',
    },
  },
  'search-gift': {
    positionRule: GRID_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_GIFT_M,
      unitIdP: AD_UNIT_IDS.SEARCH_GIFT_P,
      mWidth: 161,
      mHeight: 303,
      pWidth: 189,
      pHeight: 307,
      rounded: 'medium',
    },
  },
  'search-donation-business': {
    positionRule: GRID_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_DONATION_BUSINESS_M,
      unitIdP: AD_UNIT_IDS.SEARCH_DONATION_BUSINESS_P,
      mWidth: 335,
      mHeight: 90,
      pWidth: 600,
      pHeight: 120,
      rounded: 'medium',
    },
  },
  'search-local-market': {
    positionRule: GRID_RESULT_RULE,
    nativeSlot: {
      unitIdM: AD_UNIT_IDS.SEARCH_LOCAL_MARKET_M,
      unitIdP: AD_UNIT_IDS.SEARCH_LOCAL_MARKET_P,
      mWidth: 161,
      mHeight: 330,
      pWidth: 189,
      pHeight: 364,
      rounded: 'medium',
    },
  },
} as const satisfies Record<string, SearchAdPlacementConfig>;

export type SearchAdPlacement = keyof typeof SEARCH_AD_PLACEMENTS;
